/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Group from 'entities/Group';
import Groups from 'collections/Groups';
import GroupActions from 'groups/actions/GroupActions';
import GroupName from 'groups/components/GroupName.jsx';
import GroupSelectionDialog from 'groups/components/GroupSelectionDialog.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import Relationship from 'entities/Relationship';
import Subscriber from 'entities/Subscriber';
import Subscribers from 'collections/Subscribers';
import ToastActions from 'actions/ToastActions';
import { mountModal } from 'lib/modal';

class CopySubscriberDialog extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    relationship: PropTypes.instanceOf(Relationship).isRequired,
    groups: PropTypes.instanceOf(Groups).isRequired,
  };

  getGroupsCopyableTo = () => {
    const { relationship } = this.props;
    const subscriptions = relationship.getSubscriptionsToMe();
    return new Groups(
      this.props.groups.filter(group => {
        return !subscriptions.some(subscription => {
          return subscription.getGroupId() === group.id && !group.isStaffClass();
        });
      })
    );
  };

  confirmCopySubscriberToGroup = (group: Group) => {
    const subscriber = this.props.relationship.getRelatedUser();

    mountModal(
      <ConfirmDialog
        eventScreenName="CopySubscriberDialog"
        title={
          <span>
            Are you sure you want to copy <strong>{subscriber.getName()}</strong> to{' '}
            <GroupName group={group} />?
          </span>
        }
        onConfirm={() => {
          GroupActions.addSubscribers(group, new Subscribers([subscriber]))
            .then(() => {
              ToastActions.showSuccessToast(
                `${subscriber.getName()} was copied to ${group.getName()}`
              );
            })
            .catch(error => {
              ToastActions.showErrorToast(
                `Unable to copy ${subscriber.getName()} to ${group.getName()}`
              );
              console.warn(error, error && error.stack);
            });
          this.refs.copySubscriberDialog.hide();
        }}
        actionButtonText="Copy"
        cancelButtonText="Cancel"
      />,
      this
    );
  };

  renderEmptyMessage = (subscriber: Subscriber) => {
    if (this.props.groups.length === 0) {
      return `You don't have any groups for ${subscriber.getName()} to join yet.`;
    } else {
      return `${subscriber.getName()} has joined all of your classes.`;
    }
  };

  render() {
    const subscriber = this.props.relationship.getRelatedUser();
    const emptyMessage = this.renderEmptyMessage(subscriber);
    return (
      <GroupSelectionDialog
        {...this.props}
        ref="copySubscriberDialog"
        title={`Copy ${subscriber.getName()} to another class`}
        groups={this.getGroupsCopyableTo()}
        onSelect={this.confirmCopySubscriberToGroup}
        emptyMessage={emptyMessage}
      />
    );
  }
}

export default CopySubscriberDialog;
